var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03077 0H10.1231C11.2446 0 12.1538 0.89543 12.1538 2V14C12.1538 15.1046 11.2446 16 10.1231 16H4.03077C2.90921 16 2 15.1046 2 14V2C2 0.89543 2.90921 0 4.03077 0ZM3.84615 1.82857V6.85714H9.84615V1.82857H3.84615ZM4.34615 14.1714C4.07001 14.1714 3.84615 14.3761 3.84615 14.6286C3.84615 14.881 4.07001 15.0857 4.34615 15.0857H9.34615C9.6223 15.0857 9.84615 14.881 9.84615 14.6286C9.84615 14.3761 9.6223 14.1714 9.34615 14.1714H4.34615ZM13.5385 0.457143C13.7934 0.457143 14 0.68228 14 0.96V15.04C14 15.3177 13.7934 15.5429 13.5385 15.5429C13.2836 15.5429 13.0769 15.3177 13.0769 15.04V0.96C13.0769 0.68228 13.2836 0.457143 13.5385 0.457143Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.9398294c276637bf54aad93b967d1694.svg";
export { ForwardRef as ReactComponent };